import { IPolicyInitialValues } from '../../../types';

export const INITIAL_VALUES: IPolicyInitialValues = {
  organization: 0,
  policy_type: '',
  policy_number: '',
  upload_files: [],
  start_date: '',
  end_date: '',
};
